import React, { useState } from 'react';
import { FeedbackData } from './feedbackData';
import { BsArrowRight , BsArrowLeft } from 'react-icons/bs';


const Feedback = ({ slides}) => {
  const [ current, setCurrent ] = useState(0);
  const length = slides.length;

  const nextSlide =() => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide =() => {
    setCurrent(current === 0 ? length - 1 : current - 1);

  };
  console.log(current);

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }
  return (
    <div>
      {FeedbackData.map((slide , index) =>{
        return (
          <div className={index === current ? 'slide active' : 'slide'} key={index}>
           {index === current && (
            <div className="bg-[#E5F5EF] pt-14 pb-24">
              <div className='text-center'>
                <h1 className='text-[#1E1E1E] text-[46px] leading-[3rem] pb-10'>What Our Users Are Saying</h1>
              </div>
              <div className='flex justify-around items-center feedback-container'>
                <div>
                  <BsArrowLeft onClick={prevSlide} size={30} />
                </div>
                <div className='bg-[#f9fbf5] p-14 feedback-card'>
                  <div className='flex feedback-card-content'>
                    <img src={slide.Image} alt='' className='rounded-full w-28 h-28'/>
                    <p className='pl-14 text-xl text-[#3f3f3f] leading-7 comments'>{slide.Comment}</p>
                  </div>
                  <p className='pl-40 ml-2 text-lg font-semibold text-[#ABABAB] pt-5 company'>{slide.Company}</p>
                  <h1 className="pl-40 ml-2 text-[#52BD95] leading-8 font-bold text-2xl font-['Mulish'] owner">{slide.Name}</h1> 
                </div>
                <div >
                 <BsArrowRight onClick={nextSlide} size={30} />
                </div>
              </div>
           
            </div>
           )}
          </div>
          )})}
    </div>
  )
}

export default Feedback
